import React from "react";
import ResetPassword from "../containers/ResetPassword";
import NoNavLayout from "../layouts/NoNavLayout";

const ResetPasswordPage = props => {
  document.title = props.title;
  return (
    <NoNavLayout>
      <ResetPassword />
    </NoNavLayout>
  );
};

export default ResetPasswordPage;






// WEBPACK FOOTER //
// ./src/pages/ResetPasswordPage.js